<template>
  <v-container>
    <p>New cleaning supply</p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="supplier.name"
              label="Name"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="supplier.branch"
              label="Branch"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <app-cleaning-supply-list
          :cleaning_supply_list="cleaning_supply_list"
        />
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="createSupplier"
          >
            Create
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'supplier-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "SupplierCreate",
  components: {
    AppCleaningSupplyList: () => import('../components/cleaning-supply-list')
  },
  data: () => ({
    supplier: {
      name: null,
      branch: null
    },
    cleaning_supply_list: [],
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  mounted () {
    this.cleaning_supply_list = []
  },
  methods: {
    async createSupplier () {
      try {
        if (this.requireField()) {
          const { data } = await this.$http.post('/back-office/suppliers', this.supplier, authHeader())
          let supplier_id = data.id
          let cleaning_supplies = []
          for (let cleaning_supply of this.cleaning_supply_list) {
            if (cleaning_supply.selected)
              cleaning_supplies.push(cleaning_supply.id)
          }
          await this.$http.put(`/back-office/suppliers/${supplier_id}/cleaning-supplies`, { cleaning_supplies }, authHeader())
          this.$router.push({ name: 'supplier-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.supplier.name) {
        alert('Please fill in supplier name')
        return false
      }
      if (!this.supplier.branch) {
        alert('Please fill in supplier branch')
        return false
      }
      return true
    },
  },
};
</script>
